import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TarrifsRoutingModule } from './tarrifs-routing.module';
import { TarrifsComponent } from './tarrifs.component';
import {NgbNavModule} from '@ng-bootstrap/ng-bootstrap';
import { HomeInternetComponent } from './home-internet/home-internet.component';
import { HomeInternetTvComponent } from './home-internet-tv/home-internet-tv.component';
import { SpecialPriceComponent } from './component/special-price/special-price.component';



@NgModule({
  declarations: [TarrifsComponent, HomeInternetComponent, HomeInternetTvComponent, SpecialPriceComponent],
  imports: [
    CommonModule,
    TarrifsRoutingModule,
    NgbNavModule
  ]
})
export class TarrifsModule { }
